import { useQueryClient } from "@tanstack/react-query";
import type { FunctionComponent } from "react";
import { useCallback } from "react";

import Sidebar from "~/components/Sidebar/Sidebar.tsx";
import { invoiceRecipientQueries } from "~/modules/billing/api/invoiceRecipient/invoiceRecipientQueries.ts";
import CreateOrUpdateInvoiceRecipientForm
	from "~/modules/client/components/ClientDetailsView/components/ClientsInvoiceRecipientsList/components/CreateOrUpdateInvoiceRecipientForm";

type CreateInvoiceRecipientSidebarProps = {
	clientId: string;
	isOpen: boolean;
	onClose: () => void;
};

const CreateInvoiceRecipientSidebar: FunctionComponent<CreateInvoiceRecipientSidebarProps> = ({
	clientId,
	isOpen,
	onClose,
}) => {
	const queryClient = useQueryClient();

	const handleSuccess = useCallback(async () => {
		await queryClient.invalidateQueries({ queryKey: invoiceRecipientQueries.byClient(clientId).queryKey });
		onClose();
	}, [clientId, onClose, queryClient]);
	return (
		<Sidebar closeOnOutsideClick={false}
				 open={isOpen}
				 setOpen={onClose}>
			<>
				<CreateOrUpdateInvoiceRecipientForm
					clientId={clientId}
					onSuccess={handleSuccess}
					onCancelClick={onClose} />
			</>
		</Sidebar>
	);
};

export default CreateInvoiceRecipientSidebar;